import { render } from "./TomNumpad.vue?vue&type=template&id=04c2522e"
import script from "./TomNumpad.vue?vue&type=script&lang=js"
export * from "./TomNumpad.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__